// React Query queries for AI-powered SMS generation

import { useApiClient } from '@commander/api-client';
import { useQuery } from '@tanstack/react-query';
import { createSmsAiApi } from '../../api/smsAiApi';
import { communicationKeys } from '../communicationKeys';

/**
 * Hook to fetch AI generation result for SMS
 * @param generationId - ID of the generation to fetch
 * @param options - Query options including enabled flag
 */
export function useSmsAiGeneration(generationId: string, options?: { enabled?: boolean }) {
  const apiClient = useApiClient();
  const smsAiApi = createSmsAiApi(apiClient);

  return useQuery({
    queryKey: communicationKeys.aiGenerations.detail(generationId),
    queryFn: () => smsAiApi.getGeneration(generationId),
    enabled: options?.enabled !== false && !!generationId,
  });
}
